import { baseBackend } from "../../../../../api/base/baseUrl";

const URL_SCHEDULED = "/api/v1/settings/scheduled";

export const getScheduled = async () => {
  return await baseBackend.get(`${URL_SCHEDULED}`, {
    headers: { "Content-Type": "application/json" },
  });
};

export const updateScheduledGlobal = async (data) => {
  return await baseBackend.put(
    `${URL_SCHEDULED}-global`,
    JSON.stringify({ data }),
    { headers: { "Content-Type": "application/json" } }
  );
};

export const updateScheduledDaily = async (data) => {
  return await baseBackend.put(
    `${URL_SCHEDULED}-daily`,
    JSON.stringify({ data }),
    { headers: { "Content-Type": "application/json" } }
  );
};
